import React, { Component } from 'react';
import { apiInterfaceForJson } from '../../../../services/common/apiManager';

export default class ObjectIdRefField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            loading: false
        };
    }

    componentDidMount() {
        this.loadOptions();
    }

    loadOptions = () => {
        const { fieldDef } = this.props;
        if (!fieldDef.dataSource || !fieldDef.dataSource.endpoint) {
            return;
        }

        this.setState({ loading: true });
        const method = fieldDef.dataSource.method || 'GET';
        const params = fieldDef.dataSource.params || undefined;
        apiInterfaceForJson(fieldDef.dataSource.endpoint, method, params)
            .then((response) => {
                const data = response.data || [];
                const labelField = fieldDef.dataSource.labelField || 'name';
                const valueField = fieldDef.dataSource.valueField || '_id';
                const options = data.map((item) => ({
                    label: item[labelField],
                    value: item[valueField]
                }));
                this.setState({ options, loading: false });
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    };

    handleChange = (e) => {
        this.props.onChange(this.props.fieldDef.fieldId, e.target.value);
    };

    render() {
        const { fieldDef, value, hasError, errorMessage, disabled } = this.props;
        const isRequired = fieldDef.validation && fieldDef.validation.required;
        const options = this.state.options;

        return (
            <div className="form-group">
                <label>
                    {fieldDef.label}
                    {isRequired && <span className="text-danger"> *</span>}
                </label>
                <select
                    className={hasError ? 'form-control select is-invalid' : 'form-control select'}
                    name={fieldDef.fieldId}
                    value={value || ''}
                    onChange={this.handleChange}
                    disabled={disabled || this.state.loading}
                >
                    <option value="">{this.state.loading ? 'Loading...' : (fieldDef.placeholder || 'Select...')}</option>
                    {options.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>
                <div className={hasError ? 'inline-errormsg' : 'hidden'}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true">
                        &nbsp;{errorMessage || 'This field is required.'}
                    </i>
                </div>
            </div>
        );
    }
}
